import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/copilot/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/apps/copilot/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/app/apps/copilot/components/fragments/cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/apps/copilot/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/packages/ui/src/components/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
